import { sidebarTheme } from "@/themes/sidebar.ts";
import { AppTheme } from "@/themes/theme.types.ts";

export const DefaultAppTheme: AppTheme = {
  body: {
    base: "text-default text-base",
  },
  layout: {
    base: "flex relative",
    // min-w-0 — иначе широкие таблицы не дают flex-элементу сжаться и распирают страницу.
    main: "flex-1 min-w-0 overflow-y-auto",
  },
  sidebar: sidebarTheme,
};
